export const EmptyCellValue = (): JSX.Element => <span className='text-gray-400 font-lato'>—</span>
